<template>
  <div class="content-center none-click">
    <div class="banner">
      <img src="@/assets/Mobile/images/solution/brand-banner.png" alt="">
    </div>
    <div class="block01">
      <div class="sk-mobile-title">
        <div class="title">全终端覆盖</div>
      </div>
      <div class="content">
        <div class="item">
          <img class="bg" src="@/assets/Mobile/images/solution/app01.png" alt="">
          <img class="icon" src="@/assets/Mobile/images/solution/app-icon01.png" alt="">
          <span>PC端商城</span>
        </div>
        <div class="item">
          <img class="bg" src="@/assets/Mobile/images/solution/app02.png" alt="">
          <img class="icon" src="@/assets/Mobile/images/solution/app-icon02.png" alt="">
          <span>APP商城</span>
        </div>
        <div class="item">
          <img class="bg" src="@/assets/Mobile/images/solution/app03.png" alt="">
          <img class="icon" src="@/assets/Mobile/images/solution/app-icon03.png" alt="">
          <span>H5/公众号商城</span>
        </div>
        <div class="item">
          <img class="bg" src="@/assets/Mobile/images/solution/app04.png" alt="">
          <img class="icon" src="@/assets/Mobile/images/solution/app-icon04.png" alt="">
          <span>小程序商城</span>
        </div>
      </div>
    </div>
    <div class="block02">
      <div class="sk-mobile-title">
        <div class="title">多种电商模式支持</div>
      </div>
      <img src="@/assets/Mobile/images/solution/brand01.png" alt="">
    </div>
    <div class="block03">
      <div class="sk-mobile-title">
        <div class="title">产品特点</div>
      </div>
      <div class="content">
        <div class="item">
          <span class="title">活动组件</span>
          <div class="line" />
          <span class="text">提供多种促销活动组件，帮助企<br>业营销更多样有趣</span>
          <img src="@/assets/Mobile/images/solution/product-attr01.png" alt="">
        </div>
        <div class="item">
          <span class="title">精准营销</span>
          <div class="line" />
          <span class="text">通过对会员数据分析，为顾客提<br>供精准推荐，实现千人千面</span>
          <img src="@/assets/Mobile/images/solution/product-attr02.png" alt="">
        </div>
        <div class="item">
          <span class="title">会员权益</span>
          <div class="line" />
          <span class="text">登陆有礼、购物返利、积分商<br>城、积分抵现等多种会员权益玩<br>法，帮助企业更好流程顾客</span>
          <img src="@/assets/Mobile/images/solution/product-attr03.png" alt="">
        </div>
        <div class="item">
          <span class="title">商城DIY</span>
          <div class="line" />
          <span class="text">商城界面轻松个性定制，传递企<br>业自己的品牌和思想</span>
          <img src="@/assets/Mobile/images/solution/product-attr04.png" alt="">
        </div>
      </div>
    </div>
    <div class="block04">
      <div class="sk-mobile-title">
        <div class="title">商城后台功能</div>
      </div>
      <div class="content">
        <div class="item">
          <img src="@/assets/Mobile/images/solution/shop01.png" alt="">
          <span>商品管理</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/shop02.png" alt="">
          <span>订单管理</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/shop03.png" alt="">
          <span>促销管理</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/shop04.png" alt="">
          <span>会员管理</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/shop05.png" alt="">
          <span>短信营销</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/shop06.png" alt="">
          <span>积分系统</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/shop07.png" alt="">
          <span>在线支付</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/shop08.png" alt="">
          <span>商城装修</span>
        </div>
      </div>
    </div>
    <div class="block05">
      <div class="sk-mobile-title">
        <div class="title">丰富的营销玩法</div>
      </div>
      <div class="content">
        <a-tabs default-active-key="1">
          <a-tab-pane key="1" tab="互动小游戏">
            <div class="game-wapper">
              <div class="item">
                <img src="@/assets/Mobile/images/solution/game01.png" alt="">
                <span>小猫钓鱼</span>
              </div>
              <div class="item">
                <img src="@/assets/Mobile/images/solution/game02.png" alt="">
                <span>幸运大转盘</span>
              </div>
              <div class="item">
                <img src="@/assets/Mobile/images/solution/game03.png" alt="">
                <span>欢乐摇奖机</span>
              </div>
            </div>
          </a-tab-pane>
          <a-tab-pane key="2" tab="会员权益">
            <div class="game-wapper">
              <div class="item">
                <img src="@/assets/Mobile/images/solution/game04.png" alt="">
                <span>积分</span>
              </div>
              <div class="item">
                <img src="@/assets/Mobile/images/solution/game05.png" alt="">
                <span>优惠券</span>
              </div>
            </div>
          </a-tab-pane>
          <a-tab-pane key="3" tab="营销活动">
            <div class="game-wapper">
              <div class="item">
                <img src="@/assets/Mobile/images/solution/game06.png" alt="">
                <span>直降活动</span>
              </div>
              <div class="item">
                <img src="@/assets/Mobile/images/solution/game07.png" alt="">
                <span>秒杀活动</span>
              </div>
              <div class="item">
                <img src="@/assets/Mobile/images/solution/game08.png" alt="">
                <span>拼团活动</span>
              </div>
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>
    <div class="block06">
      <div class="sk-mobile-title">
        <div class="title">定制流程</div>
      </div>
      <img src="@/assets/Mobile/images/solution/brand02.png" alt="">
    </div>
    <Case title="品牌商城定制" />
    <ContactForm info-sources="品牌商城定制" />
  </div>
</template>

<script>
import metaInfo from '@/common/util/metaInfo'
import ContactForm from '@/Mobile/Mobilecom/ContactForm'
import Case from '@/Mobile/Mobilecom/Case'

export default {
  metaInfo: metaInfo.BrandCustom,
  components: {
    ContactForm,
    Case
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.banner {
  width: 100%;
  height: 200px;
  margin-top: 50px;
  img {
    width: 100%;
  }
}
.block01 {
  .content {
    padding: 16px 0 20px 0;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    .item {
      flex-shrink: 0;
      width: 153px;
      height: 196px;
      margin: 14px 7px;
      background: #FFFFFF;
      border: 1px solid #DDDDDD;
      position: relative;
      .bg {
        width: 100%;
        margin-bottom: 12px;
      }
      .icon {
        width: 40px;
        height: 41px;
        position: absolute;
        top: 129px;
        left: 8px;
      }
      span {
        line-height: 30px;
        font-weight: 500;
        font-size: 11px;
      }
    }
  }
}
.block02 {
  background-color: #F8FBFF;
  img {
    width: 337px;
    margin: 19px 0;
  }
}
.block03 {
  .content {
    padding: 15px 0 24px 0;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    .item {
      display: flex;
      flex-direction: column;
      flex-shrink: 0;
      width: 166px;
      height: 214px;
      margin: 5px;
      background: #F8FBFF;
      position: relative;
      justify-content: start;
      align-items: center;
      .title {
        margin-top: 18px;
        font-size: 12px;
        font-weight: bold;
        color: #3986FF;
        line-height: 16px;
      }
      .line {
        margin-top: 9px;
        width: 17px;
        height: 1px;
        border: 1px solid #47BB93;
      }
      .text {
        margin-top: 8px;
        font-size: 10px;
        font-weight: 400;
        color: #8B8FA1;
        line-height: 14px;
      }
      img {
        width: 135px;
        height: 126px;
        position: absolute;
        bottom: 0;
      }
    }
  }
}
.block04 {
  background-color: #F8FBFF;
  .content {
    padding-top: 29px;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    .item {
      display: flex;
      flex-direction: column;
      flex-shrink: 0;
      width: 88px;
      justify-content: space-around;
      align-items: center;
      img {
        width: 29px;
      }
      span {
        margin-top: 11px;
        font-size: 10px;
        font-weight: 500;
        color: #595961;
        line-height: 10px;
        margin-bottom: 25px;
      }
    }
  }
}
.block05 {
  .title {
    color: #fff !important;
  }
  /deep/ .ant-tabs-nav .ant-tabs-tab {
    color: #fff;
  }
  /deep/ .ant-tabs-nav .ant-tabs-tab-active {
    color: #fff;
    font-weight: bold;
  }
  /deep/ .ant-tabs-ink-bar {
    background-color: #fff;
  }
  width: 100%;
  height: 340px;
  background: url("~@/assets/Mobile/images/solution/brand03.png") no-repeat center;
  background-size: 100%;
  .game-wapper {
    margin-top: 18px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    .item {
      display: flex;
      flex-direction: column;
      margin: 0 16px;
      img {
        width: 88px;
        height: 160px;
      }
      span {
        margin-top: 8px;
        font-size: 8px;
        color: #FFFFFF;
        line-height: 10px;
      }
    }
  }
}
.block06 {
  img {
    margin: 16px 0 24px 0;
    width: 341px;
  }
}
</style>
